export const ActionTypes = {
  SET_USER: 'SET_USER',
  SET_ERROR: 'SET_ERROR',
  LOG_OUT: 'log_LOG_OUT',
  SET_IS_LOADING: 'set_is_loading',
};
